/**
 * Confirmation window — CONVENIENCE FALLBACK ONLY.
 *
 * The backend (notifications/confirmation.py:confirmation_window_state) is the
 * source of truth and is surfaced as `confirmation_window.state` on
 * GET /games/{id}/roster-status. This mirror exists only for instant render
 * when the backend value is not yet available.
 *
 * Rule: confirmation opens 24h before start and closes 30m after start.
 */
import { parseUTC } from './datetime';

export const CONFIRM_OPENS_HOURS_BEFORE = 24;
export const CONFIRM_GRACE_MINUTES_AFTER = 30;

export const CONFIRMATION_WINDOW = {
  BEFORE: 'before',
  OPEN: 'open',
  CLOSED: 'closed',
  BLOCKED: 'blocked',
  INVALID: 'invalid',
};

export const getConfirmationWindowState = ({ date_time, status } = {}) => {
  const s = (status || '').toLowerCase();
  if (s === 'cancelled' || s === 'completed') return CONFIRMATION_WINDOW.BLOCKED;
  const d = parseUTC(date_time);
  if (!d || isNaN(d.getTime())) return CONFIRMATION_WINDOW.INVALID;
  const t = d.getTime();
  const now = Date.now();
  const opensAt = t - CONFIRM_OPENS_HOURS_BEFORE * 3600 * 1000;
  const closesAt = t + CONFIRM_GRACE_MINUTES_AFTER * 60 * 1000;
  if (now < opensAt) return CONFIRMATION_WINDOW.BEFORE;
  if (now > closesAt) return CONFIRMATION_WINDOW.CLOSED;
  return CONFIRMATION_WINDOW.OPEN;
};
